import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { MedIconTicketComponent } from "./med-icon-ticket.component";

@NgModule({
  declarations: [
    MedIconTicketComponent,
  ],
  imports: [
    CommonModule,
  ],
  exports: [
    MedIconTicketComponent,
  ],
})
export class MedIconTicketModule { }
